import {WalletPlatform} from '@/enums/WalletPlatform'
import {isWalletConnectProvider} from '../connection/WalletConnectContext'
import {
  getWalletConnectAddress,
  resolveWalletConnectInvoke,
} from '../connection/WalletConnectConnection'
import {isOneGateNep21Provider} from '../connection/OneGateConnection'
import {invokeNep21Provider} from '../connection/Nep21Invoke'
import {WalletProviderStrategy} from './WalletProviderStrategy'

export class OneGateProvider implements WalletProviderStrategy {
  platform = WalletPlatform.ONEGATE
  nep21Name = 'OneGate'

  getAddress(provider: any) {
    if (isWalletConnectProvider(provider)) {
      return getWalletConnectAddress(provider)
    }

    if (isOneGateNep21Provider(provider)) {
      return provider.address
    }

    return provider?.account?.address ?? null
  }

  invoke(provider: any, payload: any) {
    if (isWalletConnectProvider(provider)) {
      return resolveWalletConnectInvoke(provider, payload)
    }

    if (isOneGateNep21Provider(provider)) {
      return invokeNep21Provider(provider.provider, payload)
    }

    return provider.invoke(payload)
  }
}
